// extracted by mini-css-extract-plugin
module.exports =  {"icon":"Nsr5Lfczv1Dpts3Nyvy_","description":"nMmpdh9vR8c_6LTwmsuU"};